<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('appointment_requirement')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Created_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Created_By}}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edited_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Edited_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" :label="$t('back')" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" :label="$t('save')" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_VIEW"/>
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <FormField :labelName="$t('warehouse')" fieldName="Warehouse_Code" v-model="header">
                        <CustomSelect :placeholder="$t('warehouse')" class="p-inputtext-sm" v-if="header" v-model="header.Warehouse_Code" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{ }" :disabled="!canEdit" />
                    </FormField>

                    <FormField :labelName="$t('all_company')" fieldName="Company_All" v-model="header">
                        <YNCheckbox :placeholder="$t('all_company')" :binary="true" v-if="header" v-model="header.Company_Code_All" :disabled="!canEdit" />
                    </FormField>

                    <FormField :labelName="$t('all_business_segment')" fieldName="Product_category_All" v-model="header">
                        <YNCheckbox :placeholder="$t('all_business_segment')" :binary="true" v-if="header" v-model="header.Product_Category_All" :disabled="!canEdit" />
                    </FormField>

                    <FormField :labelName="$t('all_distribution')" fieldName="Distribution_All" v-model="header">
                        <YNCheckbox :placeholder="$t('all_distribution')" :binary="true" v-if="header" v-model="header.Distribution_All" :disabled="!canEdit" />
                    </FormField>

                    <FormField :labelName="$t('all_document_type')" fieldName="Document_Type_All" v-model="header">
                        <YNCheckbox :placeholder="$t('all_document_type')" :binary="true" v-if="header" v-model="header.Document_Type_All" :disabled="!canEdit" />
                    </FormField>

                    <FormField :labelName="$t('all_order_type')" fieldName="Order_Type_All" v-model="header">
                        <YNCheckbox :placeholder="$t('all_order_type')" :binary="true" v-if="header" v-model="header.Order_Type_All" :disabled="!canEdit" />
                    </FormField>

                    <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="header">
                        <CustomSelect :placeholder="$t('company')" class="p-inputtext-sm" v-if="header" v-model="header.Company_Code" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" :disabled="header.Company_Code_All == 'Y' || !canEdit" />
                    </FormField>

                    <FormField :labelName="$t('product_category')" fieldName="Product_Category" v-model="header">
                        <CustomSelect :placeholder="$t('product_category')" class="p-inputtext-sm" v-if="header" v-model="header.Product_Category" :url="this.$API_URL + 'list/business_segment_code'" :minLength="0" :params="{ }" :disabled="header.Product_Category_All == 'Y' || !canEdit" />
                    </FormField>

                    <FormField :labelName="$t('distribution')" fieldName="Distribution" v-model="header">
                        <CustomSelect :placeholder="$t('distribution')" class="p-inputtext-sm" v-if="header" v-model="header.Distribution" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DISTRIBUTION }" :disabled="header.Distribution_All == 'Y' || !canEdit" />
                    </FormField>

                    <FormField :labelName="$t('document_type')" fieldName="Document_Type" v-model="header">
                        <CustomSelect :placeholder="$t('document_type')" class="p-inputtext-sm" v-if="header" v-model="header.Document_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.DOCUMENT_TYPE }" :disabled="header.Document_Type_All == 'Y' || !canEdit" />
                    </FormField>

                    <FormField :labelName="$t('order_type')" fieldName="Order_Type" v-model="header">
                        <CustomSelect :placeholder="$t('order_type')" class="p-inputtext-sm" v-if="header" v-model="header.Order_Type" :url="this.$API_URL + 'list/order_type_code'" :minLength="0" :params="{ }" :disabled="header.Order_Type_All == 'Y' || !canEdit" />
                    </FormField>
<!-- 
                    <FormField :labelName="$t('active')" fieldName="Active" v-model="header">
                        <YNCheckbox :placeholder="$t('active')" :binary="true" v-if="header" v-model="header.Active" :disabled="!canEdit" />
                    </FormField> -->
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
    export default {
        name: "Editor",
        data() {
            return {
                indexName: "AppointmentRequirementIndex",
                url: this.$API_URL + "appointmentrequirement/",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                formEditable: true,
            }
        },
        methods: {
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                        self.header.mode = self.mode;
                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            saveData() {
                this.$emit('block-ui');
                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            this.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            this.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        this.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.$router.push({ path: "/AppointmentRequirement/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();
        },
        computed:{
            canEdit(){
                return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
            },
            canSave(){
                return this.mode != this.$FORM_MODE_VIEW;
            }
        }
    }
</script>